/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppScenariosRouteImport } from './routes/_app/scenarios'
import { Route as AppRequestsRouteImport } from './routes/_app/requests'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppLauncherRouteImport } from './routes/_app/launcher'
import { Route as AppFaultsRouteImport } from './routes/_app/faults'
import { Route as AppEnvironmentRouteImport } from './routes/_app/environment'
import { Route as AppBalanceRouteImport } from './routes/_app/balance'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users.index'
import { Route as AppTransactionsIndexRouteImport } from './routes/_app/transactions.index'
import { Route as AppUsersIdRouteImport } from './routes/_app/users.$id'
import { Route as AppTransactionsIdRouteImport } from './routes/_app/transactions.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppScenariosRoute = AppScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsRoute = AppRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppLauncherRoute = AppLauncherRouteImport.update({
  id: '/launcher',
  path: '/launcher',
  getParentRoute: () => AppRoute,
} as any)
const AppFaultsRoute = AppFaultsRouteImport.update({
  id: '/faults',
  path: '/faults',
  getParentRoute: () => AppRoute,
} as any)
const AppEnvironmentRoute = AppEnvironmentRouteImport.update({
  id: '/environment',
  path: '/environment',
  getParentRoute: () => AppRoute,
} as any)
const AppBalanceRoute = AppBalanceRouteImport.update({
  id: '/balance',
  path: '/balance',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsIndexRoute = AppTransactionsIndexRouteImport.update({
  id: '/transactions/',
  path: '/transactions/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsIdRoute = AppTransactionsIdRouteImport.update({
  id: '/transactions/$id',
  path: '/transactions/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/audit': typeof AppAuditRoute
  '/balance': typeof AppBalanceRoute
  '/environment': typeof AppEnvironmentRoute
  '/faults': typeof AppFaultsRoute
  '/launcher': typeof AppLauncherRoute
  '/orders': typeof AppOrdersRoute
  '/requests': typeof AppRequestsRoute
  '/scenarios': typeof AppScenariosRoute
  '/transactions/$id': typeof AppTransactionsIdRoute
  '/users/$id': typeof AppUsersIdRoute
  '/transactions/': typeof AppTransactionsIndexRoute
  '/users/': typeof AppUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/audit': typeof AppAuditRoute
  '/balance': typeof AppBalanceRoute
  '/environment': typeof AppEnvironmentRoute
  '/faults': typeof AppFaultsRoute
  '/launcher': typeof AppLauncherRoute
  '/orders': typeof AppOrdersRoute
  '/requests': typeof AppRequestsRoute
  '/scenarios': typeof AppScenariosRoute
  '/': typeof AppIndexRoute
  '/transactions/$id': typeof AppTransactionsIdRoute
  '/users/$id': typeof AppUsersIdRoute
  '/transactions': typeof AppTransactionsIndexRoute
  '/users': typeof AppUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/balance': typeof AppBalanceRoute
  '/_app/environment': typeof AppEnvironmentRoute
  '/_app/faults': typeof AppFaultsRoute
  '/_app/launcher': typeof AppLauncherRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/requests': typeof AppRequestsRoute
  '/_app/scenarios': typeof AppScenariosRoute
  '/_app/': typeof AppIndexRoute
  '/_app/transactions/$id': typeof AppTransactionsIdRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/transactions/': typeof AppTransactionsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/audit'
    | '/balance'
    | '/environment'
    | '/faults'
    | '/launcher'
    | '/orders'
    | '/requests'
    | '/scenarios'
    | '/transactions/$id'
    | '/users/$id'
    | '/transactions/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/audit'
    | '/balance'
    | '/environment'
    | '/faults'
    | '/launcher'
    | '/orders'
    | '/requests'
    | '/scenarios'
    | '/'
    | '/transactions/$id'
    | '/users/$id'
    | '/transactions'
    | '/users'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/audit'
    | '/_app/balance'
    | '/_app/environment'
    | '/_app/faults'
    | '/_app/launcher'
    | '/_app/orders'
    | '/_app/requests'
    | '/_app/scenarios'
    | '/_app/'
    | '/_app/transactions/$id'
    | '/_app/users/$id'
    | '/_app/transactions/'
    | '/_app/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scenarios': {
      id: '/_app/scenarios'
      path: '/scenarios'
      fullPath: '/scenarios'
      preLoaderRoute: typeof AppScenariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/requests': {
      id: '/_app/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof AppRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/launcher': {
      id: '/_app/launcher'
      path: '/launcher'
      fullPath: '/launcher'
      preLoaderRoute: typeof AppLauncherRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/faults': {
      id: '/_app/faults'
      path: '/faults'
      fullPath: '/faults'
      preLoaderRoute: typeof AppFaultsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/environment': {
      id: '/_app/environment'
      path: '/environment'
      fullPath: '/environment'
      preLoaderRoute: typeof AppEnvironmentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/balance': {
      id: '/_app/balance'
      path: '/balance'
      fullPath: '/balance'
      preLoaderRoute: typeof AppBalanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions/': {
      id: '/_app/transactions/'
      path: '/transactions'
      fullPath: '/transactions/'
      preLoaderRoute: typeof AppTransactionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions/$id': {
      id: '/_app/transactions/$id'
      path: '/transactions/$id'
      fullPath: '/transactions/$id'
      preLoaderRoute: typeof AppTransactionsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAuditRoute: typeof AppAuditRoute
  AppBalanceRoute: typeof AppBalanceRoute
  AppEnvironmentRoute: typeof AppEnvironmentRoute
  AppFaultsRoute: typeof AppFaultsRoute
  AppLauncherRoute: typeof AppLauncherRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppRequestsRoute: typeof AppRequestsRoute
  AppScenariosRoute: typeof AppScenariosRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTransactionsIdRoute: typeof AppTransactionsIdRoute
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppTransactionsIndexRoute: typeof AppTransactionsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuditRoute: AppAuditRoute,
  AppBalanceRoute: AppBalanceRoute,
  AppEnvironmentRoute: AppEnvironmentRoute,
  AppFaultsRoute: AppFaultsRoute,
  AppLauncherRoute: AppLauncherRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppRequestsRoute: AppRequestsRoute,
  AppScenariosRoute: AppScenariosRoute,
  AppIndexRoute: AppIndexRoute,
  AppTransactionsIdRoute: AppTransactionsIdRoute,
  AppUsersIdRoute: AppUsersIdRoute,
  AppTransactionsIndexRoute: AppTransactionsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
